import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { IconContext } from 'react-icons';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const IconCss = css`
  vertical-align: text-top;
`;

function NavigationMenu({ children }) {
  return (
    <IconContext.Provider value={{ size: '1.25em', className: IconCss }}>
      { children }
    </IconContext.Provider>
  );
}

NavigationMenu.propTypes = propTypes;
export default NavigationMenu;
